"use client";

import { Col } from "@/app/components/lib/my-bootstrap";
import { Navbar, Row } from "@/utils/bootstrap";
import { PagesPaths } from "@/utils/functions/pages-paths";
import SvgBarHome from "./navigator-icons/SvgBarHome";
import SvgBarSearch from "./navigator-icons/SvgBarSearch";
import SvgBarShoppingCart from "./navigator-icons/SvgBarShoppingCart";
import SvgDashboard from "./navigator-icons/SvgDashboard";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { PropsWithChildren } from "react";
import useSellingMode from "@/hooks/useSellingMode";
import useIsClient from "@/hooks/useIsClient";

const MobileNavigator = () => {
  const getCompany = useGetCompanyQuery();
  const { enableSells } = useSellingMode();
  const { show_cart } = getCompany?.data?.result?.theme?.settings ?? {};
  const stickyBottom =
    getCompany?.data?.result?.theme?.components?.header?.mobile_style ===
    "sticky_bottom";
  const isScool = getCompany?.data?.result?.theme?.settings?.features?.school;
  const Icons = [
    <CustomLink href={"/"} key={1}>
      <SvgBarHome />
    </CustomLink>,

    show_cart && enableSells && stickyBottom ? (
      <CustomLink href={PagesPaths.cart}>
        <SvgBarShoppingCart disabled={!enableSells} isLoading={false} />
      </CustomLink>
    ) : isScool ? (
      <CustomLink href={PagesPaths.students}>
        <SvgDashboard />
      </CustomLink>
    ) : null,

    <CustomLink href={PagesPaths.search} key={2}>
      <SvgBarSearch />
    </CustomLink>,
  ];
  return (
    <>
      <div style={{ marginTop: 74 }} className="hide-margin" />
      <Navbar fixed="bottom" className="mobile-navigator">
        <Row
          xs={12}
          className="m-0 w-100 d-flex text-center align-items-center"
        >
          {Icons.map((Icon, index) => (
            <Col key={index}>{Icon}</Col>
          ))}
        </Row>
      </Navbar>
    </>
  );
};

export default MobileNavigator;

const CustomLink: React.FC<PropsWithChildren<{ href: string }>> = ({
  children,
  href,
}) => {
  const router = useRouter();
  const client = useIsClient();
  if (!client) return;
  return (
    <div
      onClick={() => router.push(href)}
      style={{ display: "flex", justifyContent: "center" }}
    >
      {children}
    </div>
  );
};
